// extracted by mini-css-extract-plugin
module.exports = {"baseSectionTitleSecondary":"BaseSectionTitleSecondary_baseSectionTitleSecondary_TjfOZ","isStyleDingBeauty":"BaseSectionTitleSecondary_isStyleDingBeauty_3vQQm"};